<template>
  <div :class="{ menu: isTakeOut }">
    <TextInput
      :value="$i18n.choice(course.names)"
      :placeholder="$t(`reserve/${type}/placeholder`)"
      :icon="SortIcon"
      :price="course.price"
      :tax="course.tax"
      show-only
      @click="courseSelectModal = true"
    />
    <div v-if="isTakeOut" class="count-wrap">
      <select v-model.number="_count" class="count" :disabled="isCourseDisabled(course.id)">
        <option v-if="isCourseDisabled(course.id)">1</option>
        <template v-else>
          <option v-for="i in max" :key="i">{{ i }}</option>
        </template>
      </select>
    </div>
    <CourseSelectModal
      v-if="courseSelectModal"
      :title="$t(`reserve/${type}/modalTitle`)"
      :current="course.id"
      :index="index"
      :selected-ids="selectedIds"
      @select="updateCourse"
      @close="courseSelectModal = false"
    />
  </div>
</template>

<script>
import CourseSelectModal from '@/components/organisms/CourseSelectModal'
import TextInput from '@/components/atoms/TextInput'
import SortIcon from '@/components/icons/SortIcon'

export default {
  name: 'CourseSelect',
  components: {
    CourseSelectModal,
    TextInput,
  },
  props: {
    /** course */
    course: { type: Object, default: null },
    /** index */
    index: { type: Number, default: null },
    /** 最大数 */
    max: { type: Number, default: 1 },
    /** テイクアウト */
    isTakeOut: { type: Boolean, default: false },
    /** menuかcourse */
    type: {
      type: String,
      default: null,
      validator(val) {
        return ['course', 'menu'].includes(val)
      },
    },
    /** 選択しているid */
    selectedIds: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      SortIcon,
      courseSelectModal: false,
    }
  },
  computed: {
    _count: {
      get() {
        return this.course.count || 1
      },
      set(count) {
        this.updateCourseCount(count)
      },
    },
  },
  methods: {
    isCourseDisabled(id) {
      return id < 0 || id === undefined
    },
    updateCourse(course) {
      this.$store.commit('reservation/edit/updateCourse', { course, index: this.index })
    },
    updateCourseCount(count) {
      this.$store.commit('reservation/edit/updateCourse', { course: { ...this.course, count }, index: this.index })
    },
  },
}
</script>

<style lang="postcss" scoped>
>>> .input {
  height: 58px;
}

.menu {
  display: flex;

  & .text-input {
    flex: 1;
    margin-right: 8px;
    @media screen and (min-width: 768px) {
      margin-right: 16px;
    }
  }

  & .count-wrap {
    width: 72px;
    @media screen and (min-width: 768px) {
      width: 84px;
    }
  }

  & + .menu {
    margin-top: 16px;
  }

  & >>> .text-input {
    cursor: pointer;
  }
}

.count-wrap {
  position: relative;

  & .count {
    appearance: none;
    background: var(--white);
    border: 1px solid var(--gray);
    border-radius: 6px;
    cursor: pointer;
    direction: rtl;
    font-size: 14px;
    height: 58px;
    line-height: 1;
    padding: 16px;
    width: 100%;

    &::-ms-expand {
      display: none;
    }

    &:disabled {
      background: var(--mostly-white-1);
    }
  }

  @media screen and (min-width: 768px) {
    &::after {
      border: 5px solid transparent;
      border-left: 5px solid var(--gray);
      box-sizing: border-box;
      content: '';
      height: 5px;
      pointer-events: none;
      position: absolute;
      right: 16px;
      top: 27px;
      transform: rotate(90deg);
      width: 5px;
    }

    & .count {
      padding: 0 40px 0 20px;
    }
  }
}

select:focus {
  outline: none;
}
</style>
